import React from "react";
import "../assets/css/styles.css";
import about_us from "../assets/images/about_us.png";
import { Check } from "../components/Icons";

const POINTS = [
  {
    title: "Know your farmer",
    body: "Every share is traced back to a local farm we have visited and vetted.",
  },
  {
    title: "Better food, fairer price",
    body: "Buying together removes the middlemen, so more of your money reaches the farm.",
  },
  {
    title: "Nothing wasted",
    body: "Whole-animal and seasonal sourcing means we use what the land actually gives.",
  },
];

const About = () => {
  return (
    <section id="about" className="section section--surface about">
      <div className="container">
        <div className="about-grid">
          <div className="about-media" data-reveal>
            <div className="about-media-frame">
              <img src={about_us} alt="Farmer Boaz produce being prepared for delivery" loading="lazy" />
            </div>
            <div className="about-badge">
              <strong>10+</strong>
              <span>local farms in our growing network</span>
            </div>
          </div>

          <div className="about-copy" data-reveal style={{ "--reveal-delay": "120ms" }}>
            <span className="eyebrow">About us</span>
            <h2>Bridging local farms and the families who value them</h2>
            <p>
              Farmer Boaz connects local farmers with health-conscious households. By delivering
              farm-fresh produce and meat straight to your home, we make unmatched quality, taste
              and freshness the easy choice — while keeping sustainable agriculture viable.
            </p>
            <p>
              Our mission is simple: empower local farmers, nurture communities and inspire
              healthier lifestyles. Join us in making a difference, one doorstep at a time.
            </p>

            <div className="about-points">
              {POINTS.map((point) => (
                <div className="about-point" key={point.title}>
                  <span className="check">
                    <Check />
                  </span>
                  <p>
                    <strong>{point.title}.</strong> {point.body}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
